import { useTranslation } from '../i18n/useTranslation';
import { AppLayout } from '../components/templates/AppLayout/AppLayout';
import { Header } from '../components/layout/Header';
import { Sidebar } from '../components/Sidebar';
import { PageContent } from '../components/templates/PageContent/PageContent';
import { PageHeader } from '../components/templates/PageHeader/PageHeader';
import { AnalyticsWorkbench } from '../components/analytics/AnalyticsWorkbench';

/** Analytics: questions about the user's own data in plain language → query, table and chart. */
export function AnalyticsPage() {
  const { t } = useTranslation();

  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="wide">
          <PageHeader title={t('analytics.title')} description={t('analytics.description')} />
          <AnalyticsWorkbench scope="user" />
        </PageContent>
      }
    />
  );
}

export default AnalyticsPage;
